import manajemenSoal from './manajemen-soal.js'
import kategori from './kategori.js'
import manajemenPaket from './manajemen-paket.js'
import irtCalibration from './irt-calibration.js'

const bankSoal = [...manajemenPaket, ...kategori, ...irtCalibration, ...manajemenSoal]

export default bankSoal

